<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({ responsibilities: { type: Array, default: () => [] } });
const { t } = useI18n();
const money = value => value?.amount || value || t('SALES.DETAIL.EMPTY_VALUE');
</script>

<template>
  <LaisCard
    :title="t('SALES.DETAIL.COMMISSION.RESPONSIBILITIES.TITLE')"
    prefix-icon="i-lucide-hand-coins"
  >
    <p v-if="!responsibilities.length" class="text-sm text-lais-text-muted">
      {{ t('SALES.DETAIL.COMMISSION.RESPONSIBILITIES.EMPTY') }}
    </p>
    <article
      v-for="responsibility in responsibilities"
      :key="responsibility.id"
      class="border-b border-lais-border-soft py-4 first:pt-0 last:border-b-0 last:pb-0"
    >
      <span
        class="rounded-full bg-emerald-100 px-2 py-1 text-xs font-bold text-emerald-800"
      >
        {{ responsibility.tipo }}
      </span>
      <dl class="mt-3 grid gap-4 text-sm sm:grid-cols-5">
        <div>
          <dt class="text-lais-text-muted">
            {{ t('SALES.DETAIL.COMMISSION.RESPONSIBILITIES.SELLER') }}
          </dt>
          <dd class="mt-1 font-semibold text-lais-text">
            {{ responsibility.name }}
          </dd>
        </div>
        <div>
          <dt class="text-lais-text-muted">
            {{ t('SALES.DETAIL.COMMISSION.RESPONSIBILITIES.TYPE') }}
          </dt>
          <dd class="mt-1 font-semibold text-lais-text">
            {{ responsibility.tipo }}
          </dd>
        </div>
        <div>
          <dt class="text-lais-text-muted">
            {{ t('SALES.DETAIL.COMMISSION.RESPONSIBILITIES.INSTALLMENT') }}
          </dt>
          <dd class="mt-1 font-semibold text-lais-text">
            {{ responsibility.numero_parcela }}
          </dd>
        </div>
        <div>
          <dt class="text-lais-text-muted">
            {{ t('SALES.DETAIL.COMMISSION.RESPONSIBILITIES.COUNT') }}
          </dt>
          <dd class="mt-1 font-semibold text-lais-text">
            {{
              responsibility.numero_parcelas || t('SALES.DETAIL.EMPTY_VALUE')
            }}
          </dd>
        </div>
        <div>
          <dt class="text-lais-text-muted">
            {{ t('SALES.DETAIL.COMMISSION.RESPONSIBILITIES.VALUE') }}
          </dt>
          <dd class="mt-1 font-semibold text-lais-text">
            {{ money(responsibility.parcela_valor) }}
          </dd>
        </div>
      </dl>
    </article>
  </LaisCard>
</template>
